export default __webpack_public_path__ + "static/media/iab-step-share-img.3dfa8a1b.png";